<template>
<div>
  <b-loading :active="loading" :is-full-page="false" />
  <template v-if="!loading">
    <cytomine-modal :active="active" :title="$t('add-case-to-worklist')" @close="$emit('update:active', false)">
      
      <div class="section-title">{{ $t('create-case') }}</div>
      
      <b-field :label="$t('name')" :type="{ 'is-danger': errors.has('newCaseName') }" :message="errors.first('newCaseName')">
        <b-input
          v-model="newCaseName"
          name="newCaseName"
          v-validate="'required|trim_max_150'"
          :placeholder="$t('new-case-name')"
        />
      </b-field>

      <!-- <b-field :label="$t('ontology')">
        <b-radio v-model="ontology" native-value="NEW">
          {{ $t('create-ontology-for-case') }}
        </b-radio>
      </b-field>
      <b-field>
        <b-radio v-model="ontology" native-value="EXISTING">
          {{ $t('use-existing-ontology') }}
        </b-radio>
      </b-field>
      <b-field>
        <b-radio v-model="ontology" native-value="NO">
          {{ $t('no-ontology') }}
        </b-radio>
      </b-field> -->

      <template v-if="ontology === 'EXISTING'">
        <b-field :type="{ 'is-danger': errors.has('ontology') }" :message="errors.first('ontology')">
          <b-select
            size="is-small"
            v-model="selectedOntology"
            :placeholder="$t('select-ontology')"
            name="ontology"
            v-validate="'required'"
          >
            <option v-for="ontology in ontologies" :value="ontology.id" :key="ontology.id">
              {{ ontology.name }}
            </option>
          </b-select>
        </b-field>
      </template>

      <button class="button is-link" @click="createProject" :disabled="isCreateDisabled">
        {{ $t('create-case') }}
      </button>

      <hr />
      <div class="section-title" style="margin-top: 1.5rem;">{{ $t('existing-cases') }}</div>
      
      <div class="display-flex-row" style="align-items: center;">
        <b-input v-model="name" name="name" @input="onNameInput" :placeholder="$t('search')" style="flex: 1;" />
      </div>
      <div style="max-height: 30vh; overflow-y: scroll; margin: 0.4rem 0px 1.5rem;">
        <div
          v-for="project in filteredNotIncluded"
          :key="project.id"
          class="project-item"
          :class="{ selected: selectedProjectId === project.id }"
          @click="selectProject(project.id)"
        > {{ project.name }} </div>

        <div
          v-for="project in filteredAlreadyIncluded"
          :key="project.id"
          class="project-item included-item"
        > {{ project.name }} </div>
      </div>

      <template #footer>
        <button class="button" type="button" @click="$emit('update:active', false)">
          {{ $t('button-cancel') }}
        </button>
        <button class="button is-link" :disabled="errors.any() || selectedProjectId==null" @click="clickAdd(selectedProjectId)">
          {{ $t('button-save') }}
        </button>
      </template>
    </cytomine-modal>
  </template>
</div>
</template>

<script>
import {ProjectCollection, Ontology, Project, OntologyCollection} from 'cytomine-client';
import {WorklistProject} from 'cytomine-client';
import CytomineModal from '@/components/utils/CytomineModal';
import { normalizeName, normalizeNameForCompare } from '@/utils/string-utils';
import { Validator } from 'vee-validate';

export default {
  name: 'add-project-to-worklist-modal',
  props: {
    revision : {type: Number, default: 0},
    active: Boolean,
    // ontologies: Array,
    // worklist: Object,
    existProjects: {
      // type: Object,
      type: Array,
      required: false,
      default: null
    },
  },
  components: {CytomineModal},
  $_veeValidate: {validator: 'new'},
  data() {
    return {
      loading: false,
      name: '',
      ontology: 'NEW',
      ontologies: [],
      selectedOntology: null,
      
      projects: [],

      selectedProjectId: null,
      newCaseName: '',
      
      notIncludedList: [],
    };
  },
  watch: {
    async active(val) {
      if(val) {
      // 1. 입력 필드 초기화
        this.name = '';
        this.ontology = 'NEW';
        this.selectedOntology = null;
        this.newCaseName = '';
        this.selectedProjectId = null;

        // 2. 모달이 열릴 때마다 최신 데이터 로드
        this.loading = true;
        try {
          await Promise.all([
            this.fetchProject(),
            this.fetchOntologies(),
          ]);
        }
        catch(error) {
          console.error(error);
        }
        finally {
          this.loading = false;
        }
      }
    }
  },
  computed: {
    currentWorklist() {
      return this.$store.getters['worklist/getCurrentWorklist'];
    },
    idWorklist() {
      return this.$route.params.idWorklist;
    },
    isCreateDisabled() {
      return !normalizeName(this.newCaseName) ||
      (this.ontology === 'EXISTING' && !this.selectedOntology);
    },
    filteredAllProjects() {
      const keyword = normalizeNameForCompare(this.name);
      if (!keyword) return this.projects;
      return this.projects.filter(p => normalizeNameForCompare(p.name).includes(keyword));
    },
    // 2. 필터링된 것 중 '미포함' 목록
    filteredNotIncluded() {
      const existIds = new Set(this.existProjects.map(p => p.id));
      return this.filteredAllProjects.filter(p => !existIds.has(p.id));
    },
    // 3. 필터링된 것 중 '이미 포함' 목록
    filteredAlreadyIncluded() {
      const existIds = new Set(this.existProjects.map(p => p.id));
      return this.filteredAllProjects.filter(p => existIds.has(p.id));
    }
  },
  methods: {
    async createProject() {
      let result = await this.$validator.validateAll();
      if(!result) {
        return;
      }

      const normalizedCaseName = normalizeName(this.newCaseName);
      if(!normalizedCaseName) {
        return;
      }

      this.loading = true;
      
      try {
        let idOntology;
        if(this.ontology === 'NEW') {
          let ontology = await new Ontology({name: normalizedCaseName}).save();
          idOntology = ontology.id;
        }
        else if(this.ontology === 'EXISTING') {
          idOntology = this.selectedOntology;
        }

        let project = await new Project({ name: normalizedCaseName, ontology: idOntology }).save();
        console.log('created project', project);
        
        // Add the newly created project to the worklist
        await this.clickAdd(project.id);

        this.loading = false;
        this.$notify({type: 'success', text: this.$t('notif-success-case-creation')});
        
        // Emit event to refresh sidebar worklist count
        this.$root.$eventBus.$emit('refreshWorklist');
        
        this.$emit('update:active', false);
      }
      catch(error) {
        this.loading = false;
        if(error.response && error.response.status == 409) {
          this.$notify({type: 'error', text: this.$t('notif-error-case-already-exists')});
        }
        else {
          this.$notify({type: 'error', text: this.$t('notif-error-case-creation')});
        }
      }
    },
    async clickAdd(projectId) {
      try {
        // Add case to worklist
        await new WorklistProject({worklistId: this.currentWorklist.id, projectId}).save();
        
        // Emit event to refresh sidebar worklist count
        this.$root.$eventBus.$emit('refreshWorklist');
        
        // Emit event to parent to refresh the list
        this.$emit('update:revision', this.revision + 1);
        
        // Close modal
        this.$emit('update:active', false);
        
        this.$notify({type: 'success', text: this.$t('notif-success-case-added-to-worklist')});
      }
      catch(error) {
        console.error('Error adding case to worklist:', error);
        this.$notify({type: 'error', text: this.$t('notif-error-case-added-to-worklist')});
      }
    },
    onNameInput() {
      const keyword = normalizeName(this.name);

      // 검색 결과 중 추가 가능한 첫 번째 항목을 자동 선택
      if (keyword && this.filteredNotIncluded.length > 0) {
        this.selectedProjectId = this.filteredNotIncluded[0].id;
      }
      else {
        this.selectedProjectId = null;
      }
    },

    selectProject(projectId) {
      // Check if case is already in the worklist
      for (const existProject of this.existProjects) {
        console.log('existProject', existProject.id, projectId);
        if (existProject.id == projectId) {
          console.log('이미 추가된 케이스입니다.', projectId, existProject.id);
          return;
        }
      }
      this.selectedProjectId = projectId;
    },
    async fetchProject() {
      const collection = await ProjectCollection.fetchAll();
      this.projects = collection._data || [];
    },
    async fetchOntologies() {
      let ontologies = (await OntologyCollection.fetchAll({light: true})).array;
      ontologies.sort((a, b) => a.name.localeCompare(b.name));
      console.log('fetch ontologies: ', ontologies);
      this.ontologies = ontologies;
    },
  },
  async created() {
    Validator.extend('trim_max_150', {
      getMessage: () => this.$t('error-case-name-max-length'), 
      validate: value => {
        if (!value) return true;
        return value.trim().length <= 150;
      }
    });

    // Fetch all cases accessible to the current user
    // Display them on screen with ability to search and select multiple
    // Add multiple cases to worklist at once
    try {
      await Promise.all([
        this.fetchProject(),
        this.fetchOntologies(),
      ]);
    }
    catch(error) {
      console.log(error);
      this.error = true;
    }
  },
};
</script>


<style scoped>

.project-item {
  margin: 6px 0;
  padding: 6px 12px;
  border-bottom: 1px solid #ccc;
  cursor: pointer;
}

.project-item.selected {
  background-color: #d0ebff; /* 하늘색 */
}

.display-flex-row {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}

.included-item {
  background-color: #e8e8e8;
  color: #a4a4a4;
}

.section-title {
  font-size: 1.1em;
  font-weight: 600;
  margin-bottom: 1rem;
}

.info-message {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.75rem;
  background-color: #e7f5ff;
  border-radius: 4px;
  margin-bottom: 1rem;
  font-size: 0.9em;
  color: #1971c2;
}

</style>